//将所有图片shape,转化为本地地址,并添加上realWidth,realHeight.
export async function imgHandler(layout) {
    let proList = layout.shapes.filter(shape => shape.type === 'img').map(shape => {
        let img;
        if (typeof shape.content === 'string') {
            let src = shape.content;
            img = document.createElement('img');
            img.setAttribute("crossOrigin", 'anonymous');
            img.src = src;
        }
        else if (typeof shape.content === 'object') {
            img = shape.content;
        }
        else {
            console.log('图片content错误:', shape);
            return Promise.reject('图片content错误');
        }

        shape.content = img;
        if (img.complete) {
            return Promise.resolve();
        }
        return new Promise((rsv, rej) => {
            img.onload = function () {
                if (!shape.other) {
                    shape.other = {};
                }
                Object.assign(shape.other, {
                    realWidth: img.width,
                    realHeight: img.height
                });
                rsv();
            };
            img.onerror = () => {
                console.log('图片加载失败:', shape);
                rej();
            };
        });
    });
    await Promise.all(proList);
    return layout;
}
export function textHandler(layout) {
    layout.shapes.forEach(shape => {
        if (shape.type === 'text') {
            shape.content = textWrap(shape.content);
        }
    });
    return layout;
}
function textWrap(text) {
    let reg = /(.*)\n|(.+$)/g, list = [], result;
    while (result = reg.exec(text)) {
        let paragrah = result[1] || result[2];
        if (!paragrah) {
            paragrah = ' ';
        }
        list.push(paragrah);
    }
    return list;
}
